/** ProductsWithIdSchema */
export interface ProductsSchema {
  /** Id */
  id?: number;
  /** Art Cod */
  art_cod: string;
  /** Art Type Cod */
  art_type_cod?: string;
  /** Art Des It */
  art_des_it?: string;
  /** Art Des Cmpy */
  art_des_cmpy?: string;
  /** Prod Line Cod */
  prod_line_cod?: string;
  /** Ref Cmpy Cod */
  ref_cmpy_cod?: string;
  /** Base Um */
  base_um?: string;
  /** Min Qty */
  min_qty?: number;
  /** Bdg Cls Cod */
  bdg_cls_cod?: string;
  /** Prod Stat Cod */
  prod_stat_cod?: string;
  /** Prod Stat Des */
  prod_stat_des?: string;
  /** Pso Art Status Cod */
  pso_art_status_cod?: string;
  /** Prezzo */
  prezzo?: number | null;
  /** Resa */
  resa?: number;
  /** Unita Mis Resa */
  unita_mis_resa?: string;
  /** Spessore Min */
  spessore_min?: number;
  /** Link Scheda Tecnica */
  link_scheda_tecnica?: string;
  /** Link Dop */
  link_dop?: string;
  /** Link Cam */
  link_cam?: string;
  /** Link Epd */
  link_epd?: string;
  /** Link Sts */
  link_sds?: string;
  /** Link Boc */
  link_voc?: string;
  /** Link Video */
  link_video?: string;
  /** Link Image */
  link_image?: string;
  /** Flg Kpi */
  flg_kpi?: boolean;
  /** Flg Active */
  active: boolean;
  /** Flg Manual */
  manual: boolean;

  /**
   * KCOLOR STUFF
   */
  product_des: string;
  code: string;
  prezzo_confezione?: number | null;
}

/** ProductsWithIdSchema */
export interface ProductsWithIdSchema extends ProductsSchema {
  /** R Perm */
  r_perm?: string[];
  /** W Perm */
  w_perm?: string[];
  /** Id */
  id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** SystemsWithIdSchema */
export interface SystemsWithIdSchema {
  /** Base Cod Art */
  base_cod_art?: string;
  /** Ciclo */
  ciclo?: string;
  /** Flg Scomposto */
  flg_scomposto?: boolean;
  /** Flg Tintometro */
  flg_tintometro?: boolean;
  /** Kk1 */
  kk1?: string;
  /** Kk150 */
  kk150?: string;
  /** R Perm */
  r_perm?: string[];
  /** W Perm */
  w_perm?: string[];
  /** Id */
  id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

export enum ServiceConfigurationOutputVisibilityFlag {
  NONE = 0,
  WEB = 1 << 0,
  PDF = 1 << 1,
}

export interface QuotationSurveyPrepopulationRuleSchema {
  id_design_service: number;
  value_type: "fixed" | "dynamic";
  value:
    | number // fixed numeric value, fixed option id, dynamic output id
    | number[] // fixed option ids
    | string // fixed text value
    | boolean; // fixed boolean value
  dependencies?: string[];
}

export interface QuotationSurveyRecursiveCopyMappingRuleSchema {
  id_src_question: number;
  id_dst_question: number;
  options_mapping?: {
    [key: number]: number;
  };
}

export interface QuotationSurveyRecursiveCopySettingsSchema {
  id_design_service: number;
  id_source_recursive_question: number;
  questions_mapping: QuotationSurveyRecursiveCopyMappingRuleSchema[];
}

export interface QuotationSurveyPrepopulationLogicSchema {
  type: "simple" | "recursive_copy";
  rules?: QuotationSurveyPrepopulationRuleSchema[];
  recursive_copy_settings?: QuotationSurveyRecursiveCopySettingsSchema[];
}

/** Services_configurationsSchema */
export interface ServicesConfigurationsWithIdSchema {
  /** Type */
  type: string;
  /** Name */
  name?: string;
  /** Title */
  title?: string;
  /** Column Name */
  column_name?: string;
  /** Description */
  description?: string;
  /** Service Id */
  service_id?: number;
  /** Order */
  order?: number;
  /** Step Id */
  step_id?: number;
  /** Recursive Question Id */
  recursive_question_id?: number;
  /** Input Id */
  input_id?: number;
  /** Input Type */
  input_type?: string;
  /** Output Type */
  output_type?: string;
  /** Output Input Id */
  output_input_id?: number;
  /** Product Id */
  product_id?: number;
  /** System Id */
  system_id?: number;
  /** Option Value */
  option_value?: string;
  /** Image Filename */
  image_filename?: string;
  /** Alert Type */
  alert_type?: string;
  /** Dependencies */
  dependencies?: string[];
  /** Calculation */
  calculation?: string[];
  /** Required */
  required: boolean;
  /** Output Currency */
  output_currency: boolean;
  /** Output Thickness */
  output_thickness: 1 | 2 | 3;
  /** Output Ceil */
  output_ceil: boolean;
  /** Button Select Question */
  button_select_question: boolean;
  /** Hidden Question */
  hidden_question?: string[];
  /** Active */
  active: boolean;
  /** R Perm */
  r_perm?: string[];
  /** W Perm */
  w_perm?: string[];
  /** Id */
  id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  product: ProductsWithIdSchema | null;
  system: SystemsWithIdSchema | null;
  flg_output_visibility: ServiceConfigurationOutputVisibilityFlag | null;
  flg_subtotal: boolean;
  metadata_?: { [key: string]: any };
  design_survey_prepopulation_logic?: QuotationSurveyPrepopulationLogicSchema;
}

export interface CrossServicesConfigurationWithIdSchema {
  id: number;
  service_block_id: number;
  service_block_version: number;
  block_id: number;
  block_version: number;
  version: number;
  dependencies?: string[] | null;
  calculation?: string[] | null;
  active?: boolean | null;
  flg_output_visibility?: ServiceConfigurationOutputVisibilityFlag | null;
  r_perm?: string[] | null;
  w_perm?: string[] | null;
  created_at?: string | null;
}

export enum ServiceClass {
  DESIGN = 0,
  QUOTATION = 1,
}

export interface AssociatedServicesConfigSchema {
  [key: number]: {
    r_perm?: string[];
  };
}

/** ServicesWithIdSchema */
export interface ServicesWithIdSchema {
  /** Name */
  name: string;
  /** Description */
  description?: string;
  /** Type */
  type: string;
  /** Order */
  order?: number;
  /** Active */
  active: boolean;
  /** Class */
  class: ServiceClass;
  /** ID associated services */
  associated_services: AssociatedServicesConfigSchema;
  /** R Perm */
  r_perm?: string[];
  /** W Perm */
  w_perm?: string[];
  /** Id */
  id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  has_active_aps: boolean;
  active_version: number;
  metadata_: object;
}

export interface WorksiteTypesWithIdSchema {
  /** Cod Worksite Type */
  cod_worksite_type: string;
  /** Des Worksite Type */
  des_worksite_type: string;
  /** Icon Name */
  icon_name: string;
  /** Color */
  color: string;
  /** Order */
  order: number;
  /** R Perm */
  r_perm?: string[];
  /** W Perm */
  w_perm?: string[];
  /** Id */
  id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

export interface WorksiteSimpleSchema {
  id: number;
  address: string;
  house_number: string;
  city: string;
  zip_code?: string;
  cod_province: string;
  des_province: string;
  cod_worksite_type?: string;
  cod_worksite_construction?: string;
  r_perm?: string[];
  estime_date_start?: string;
  estime_date_end?: string;
  cod_worksite_status?: object;
  des_worksite: string;
}

export interface WorksitesSchema {
  des_worksite: string;
  latitude: number;
  longitude: number;
  address: string;
  city: string;
  cod_province: string;
  des_province: string;
  des_state: string;
  cod_country: string;
  des_country: string;
  house_number: string;
  zip_code?: string;
  cod_worksite_type?: string;
  images_urls?: object;
  des_seismic_classification?: string;
  des_climate_classification?: string;
  cod_worksite_status?: object;
  cod_worksite_construction?: string;
  r_perm?: string[];
  w_perm?: string[];
  id_creator?: number;
  flg_test: boolean;
  cod_report_field?: number;
  cod_reporter?: number;
  estime_date_start?: string;
  estime_date_end?: string;
  terminated?: object;
  business: string;
}


export interface WorksitesWithIdSchema extends WorksitesSchema {
  id: number;
  created_at: string;
  worksite_types: WorksiteTypesWithIdSchema;
  shared_with_ids?: number[];
}

/** SurveySchema */
export interface SurveySchema {
  /** Id */
  id: number;
  /** Name */
  name?: string;
  /** Worksite Id */
  worksite_id?: number;
  /** Service Id */
  service_id?: number;
}

export interface ServiceSurveysWithIdSchema extends SurveySchema {
  /** Complete */
  complete: boolean;
  /** Closed */
  closed: boolean;
  /** First Render */
  first_render?: boolean;
  /** Id Creator */
  id_creator?: number;
  /** Id Modifier */
  id_modifier?: number;
  /**
   * Modified At
   * @format date-time
   */
  modified_at?: string;
  /** R Perm */
  r_perm?: string[];
  /** W Perm */
  w_perm?: string[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  services: ServicesWithIdSchema | null;
  worksites: WorksitesWithIdSchema | null;
  id_source_surveys: number[];
  service_version: number;
}

/** Service_survey_responsesWithIdSchema */
export interface ServiceSurveyResponsesWithIdSchema {
  /** Value */
  value?: string;
  /** Service Survey Id */
  service_survey_id?: number;
  /** Configuration Input Id */
  configuration_input_id?: number;
  /** Configuration Option Id */
  configuration_option_id?: number;
  /** Recursive Question Value */
  recursive_question_value?: object[];
  /** R Perm */
  r_perm?: string[];
  /** W Perm */
  w_perm?: string[];
  /** Id */
  id: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  service_surveys: ServiceSurveysWithIdSchema | null;
  services_configurations: ServicesConfigurationsWithIdSchema | null;
}

/** BusinessSchema */
export interface BusinessSchema {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** RoleSchema */
export interface RoleSchema {
  /** Name */
  name: string;
  /** Description */
  description?: string;
  /** Scopes */
  scopes: string;
  business?: BusinessSchema;
}

/** UserWithRoleSchema */
export interface UserWithRoleSchema {
  /** Email */
  email?: string;
  /** Role Id */
  role_id: number;
  /** Flg Internal */
  flg_internal?: boolean;
  /** Flg Active */
  flg_active?: boolean;
  has_revit_plugin?: boolean;
  /** Firstname */
  firstname: string;
  /** Lastname */
  lastname: string;
  /** Countries */
  countries: string;
  /** Id Salesforce */
  id_salesforce?: string;
  /** Id Manager Salesforce */
  id_manager_salesforce?: string;
  /** Id Agente */
  id_agente?: string;
  /** Id Manager */
  id_manager?: string;
  /** Role Hierarchy */
  role_hierarchy?: string;
  /** Agente Ed */
  agente_ed?: string;
  /** Agente Pos */
  agente_pos?: string;
  /** Field Ed */
  field_ed?: string;
  /** Field Pos */
  field_pos?: string;
  /** Field Sup */
  field_sup?: string;
  /** Flg Gdpr */
  flg_gdpr?: boolean;
  /** Flg Mktg */
  flg_mktg?: boolean;
  /** Interest */
  interest?: string;
  /** City */
  city?: string;
  /** Zip Code */
  zip_code?: string;
  /** Cod Province */
  cod_province?: string;
  /** Des Province */
  des_province?: string;
  /** Des State */
  des_state?: string;
  /** Cod Country */
  cod_country?: string;
  /** Des Country */
  des_country?: string;
  /** Status */
  status?: string;
  /** Churn Reason */
  churn_reason?: string;
  /**
   * Created At
   * @format date-time
   */
  created_at?: string;
  /** Company */
  company?: string;
  /** Id */
  id: number;
  /** Full Name */
  full_name: string;
  /** Merged In */
  merged_in?: number;
  /** Merged At */
  merged_at?: Date;
  role: RoleSchema;
  company_info?: any;
  account_user?: UserWithRoleSchema | null;
  vat?: string;
}

/** UserReducedSchema */
export interface  UserReducedSchema {
  id: number;
  company: string | null;
  email: string;
  name: string;
  role: string;
  // for resales info
  address?: string
  type?: string // CLI / DEST
  // adding info of the account user
  account_user_id?: number | null;
  account_user_role?: string | null;
  account_user_company?: string | null;
  account_user_email?: string | null;
  account_user_name?: string | null;
}

/**
 * KCCOptimizationType
 * An enumeration.
 */
export type KCCOptimizationType = "local" | "remote";

/** OptimizationResultSchema */
export interface OptimizationResultSchema {
  /** Cod Color */
  cod_color: string;
  /** Cod System */
  cod_system: number;
  /** Lst Primers */
  lst_primers: string[];
  /** Lst Reti */
  lst_reti: string[];
  /** Lst Rasanti */
  lst_rasanti: string[];
  /** Val Surface */
  val_surface: number;
  /** Is Tintometrist Version */
  is_tintometrist_version: boolean;
  /** Cod Survey */
  cod_survey?: number;
  /** Id */
  id: number;
  /** An enumeration. */
  cod_type: KCCOptimizationType;
  /** Value */
  value: object[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/**
 * DiscountRule
 * An enumeration.
 */
export type DiscountRule =
  | "absolute"
  | "absolute_percentage"
  | "discount_rule_1"
  | "no_discount";

export interface ServiceExtendedSchema extends ServicesWithIdSchema {
  configurations: ServicesConfigurationsWithIdSchema[];
}

export interface QuotationValueSchema {
  /** Value */
  value?: boolean | number | string | number[];
  /** Recursive Questions Mapping */
  recursive_questions_mapping?: RecursiveMappingSchema[];
}

/** RecursiveMappingSchema */
export interface RecursiveMappingSchema {
  /** Source Survey Id */
  id_design_service: number;
  /** Source Conf Id */
  id_source_recursive_question: number;
  /** Values */
  values: RecursiveMappingValueSchema[];
}

/** RecursiveMappingValueSchema */
export interface RecursiveMappingValueSchema {
  /** Source Conf Input Id */
  id_src_question: number;
  /** Destination Conf Input Id */
  id_dst_question: number;
  /** Option Mappings */
  options_mapping?: Record<string, number>;
}

export interface GenerateQuotationPayloadSchema {
  /** Quotations Questions Values */
  quotations_questions_values: Record<string, QuotationValueSchema>;
  /** Source Surveys Ids */
  source_surveys_ids: number[];
}

export interface OutputRangeSchema {
  /** key */
  key: string;
  /** Sheet */
  sheet: string;
  /** Range */
  range: string;
  /** type */
  type: string;
}

export interface SpreadsheetSchema {
  /** id */
  id: number;
  /** spreadsheet id */
  spreadsheet_id: string;
  /** spreadsheet name */
  spreadsheet_name: string;
  /** sheets */
  sheets: string[];
  /** output ranges */
  output_ranges: OutputRangeSchema[];
}
/** Worksite Sharing */
export interface WorksitesSharingSchema {
  /** Worksite Id */
  worksite_id: number;
  /** Sharing */
  sharing: any[];
}

export interface WorksiteImageSchema {
  image_url: string;
  des_image: string | null;
}

export interface ServiceSurveyResponsesSchema {
  /** Value */
  value?: string;
  /** Service Survey Id */
  service_survey_id?: number;
  /** Configuration Input Id */
  configuration_input_id?: number;
  /** Configuration Option Id */
  configuration_option_id?: number;
  /** Recursive Question Value */
  recursive_question_value?: object[];
  /** Note */
  note?: string;
  /** R Perm */
  r_perm?: string[];
  /** W Perm */
  w_perm?: string[];
}

/** KccOptimizationResultSchema */
export interface KccOptimizationResultSchema {
  /** Cod Color */
  cod_color: string;
  /** Cod System */
  cod_system: number;
  /** Lst Primers */
  lst_primers: string[];
  /** Lst Reti */
  lst_reti: string[];
  /** Lst Rasanti */
  lst_rasanti: string[];
  /** Val Surface */
  val_surface: number;
  /** Is Tintometrist Version */
  is_tintometrist_version: boolean;
  /** Cod Survey */
  cod_survey?: number;
  /** Id */
  id: number;
  /** An enumeration. */
  cod_type: KCCOptimizationType;
  /** Value */
  value: object[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** WorksitesNotesSchema */
export interface WorksitesNotesSchema {
  /** Cod Worksite */
  cod_worksite: number;
  /** Cod Worksite Activity */
  cod_worksite_activity?: number;
  /** Cod Author */
  cod_author: number;
  /** Val Author */
  val_author: string;
  /** Val Author Role Type */
  val_author_role_type: string;
  /** Val Contents */
  val_contents: object;
  /** Lst Mentions */
  lst_mentions: number[];
  /** Flg Deleted */
  flg_deleted?: boolean;
  /**
   * Edited At
   * @format date-time
   */
  edited_at?: string;
  /** Attachments Urls */
  attachments_urls?: object;
  /** R Perm */
  r_perm?: string[];
  /** W Perm */
  w_perm?: string[];
}

/** WorksitesNotesWithIdSchema */
export interface WorksitesNotesWithIdSchema extends WorksitesNotesSchema {
  /** Id */
  id?: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

export interface UsersMinimalSchema {
  id: number;
  name: string;
  role_name: string;
  role_hierarchy: string;
  account_user_role_name: string;
}

/** NotificationsSchema */
export interface NotificationsSchema {
  /** Cod User */
  cod_user: number;
  /** Val Type */
  val_type: string;
  /** Cod Worksite */
  cod_worksite?: number;
  /** Cod Reference */
  cod_reference?: number;
  /** Cod Note */
  cod_note?: number;
  /** Cod Task Activity */
  cod_task_activity?: number;
  /** Cod Survey */
  cod_survey?: number;
  /** Cod Worksite Task */
  cod_worksite_task?: number;
  /** R Perm */
  r_perm?: string[];
  /** W Perm */
  w_perm?: string[];
}

/** NotificationsWithIdSchema */
export interface NotificationsWithIdSchema extends NotificationsSchema {
  id: number;
}